import type { SimpleVehicleProps } from '../types/types'

export function hasDeviationsOrWarnings(car: SimpleVehicleProps) {
  return !!car.deviations?.length || !!car.warnings?.length
}
